import * as React from 'react';
import { Component } from 'react';
import styles from '../../styles/flyouts/tasks/Files.scss';
import { withRouter } from 'react-router';
import {
  __,
  bytesToSize,
  dateFrom,
  mapStateToProps,
  scrollToBottom,
  timeFrom,
} from '../../core/utils';
import DownloadIcon from '../../assets/images/download-15x15.svg';
import * as _ from 'lodash';
import ReactDropzone from 'react-dropzone';
import classNames from 'classnames';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import autobind from 'autobind-decorator';
import { setNotification } from '../../redux/actions/general/notification';
import {
  downloadTaskFiles,
  listAllTasks,
  uploadTaskFiles,
} from '../../redux/actions/table/all_tasks';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import { showLightbox } from '../../redux/actions/general/lightbox';
import FilePreview from '../../components/FilePreview';
import Avatar from '../../components/Avatar';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import Dropdown from '../../components/Dropdown';
import { linkFilesToModel } from '../../redux/actions/table/files';

@withRouter
@mapStateToProps((state) => ({
  user_id: state.auth.id,
  clicked_row: _.get(state.table, ['all_tasks', 'clicked_row']),
  wizard_active: _.get(state.table, ['all_tasks', 'wizard_active']),
}))
class Files extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showArchivedFiles: false,
    };
  }

  @autobind
  _handleDrop(acceptedFiles, rejectedFiles) {
    this.setState({ drag: false });

    const { data } = this.props;

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('tasks.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('tasks.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 100000000;
        })
      ) {
        setNotification({
          text: __('tasks.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        setNotification(__('tasks.files.upload.uploading'));

        uploadTaskFiles(data.id, acceptedFiles)
          .then(() => {
            setNotification(__('tasks.files.upload.uploaded'));

            this.props.match.params.stage &&
              listAllTasks(this.props.match.params.stage);

            this.props.readAction(data.id).then(() => {
              scrollToBottom(this.refs.scroll);
            });
          })
          .catch(({ status }) => {
            setNotification({
              text: __('tasks.files.upload.upload-limit'),
              type: 'warning',
            });
          });
      }
    }
  }

  @autobind
  _downloadFile(row, download = false) {
    if (row.ext == 'pdf' && download == false) {
      window.open(row.stream_url, '_blank');
    } else {
      setNotification(__('tasks.files.download.continue'));

      window.open(row.download_url, '_blank');
    }
  }

  @autobind
  _downloadFiles() {
    const { data } = this.props;

    downloadTaskFiles(data.id);

    setNotification(__('tasks.files.zip_file_generation_in_progress'));
  }

  @autobind
  _refreshTask() {
    const { data } = this.props;

    return this.props.readAction(data.id).then(() => {
      scrollToBottom(this.refs.scroll);
    });
  }

  @autobind
  _openEditAttachment(row) {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'task',
        task_id: this.props.data.id,
      },
    });
  }

  @autobind
  _openUploadAttachmentVersion(row) {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'task',
        task_id: this.props.data.id,
      },
    });
  }

  @autobind
  _archiveAttachment(row) {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __('attachments.alert.unarchive-file')
        : __('attachments.alert.archive-file'),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive')
            : __('attachments.button.archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __('attachments.notification.unarchived')
                  : __('attachments.notification.archived'),
              );
              this._refreshTask();
            });
          },
        },
      ],
    });
  }

  @autobind
  _deleteFile(row) {
    const { data } = this.props;

    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'files.general.alert.want-delete-file-attachment-task.process-cannot-undone',
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();

              setNotification(
                __('files.notification.selected-file-attachment-deleted-task'),
              );

              this.props.readAction(data.id).then(() => {
                scrollToBottom(this.refs.scroll);
              });
            });
          },
        },
      ],
    });
  }

  @autobind
  _openLinkExistingFilesWizard() {
    const { data } = this.props;
    const stage_id = _.get(data, 'stage.id') || this.props.match.params.stage;

    hideDropdown();
    setAttachmentParams({
      link_existing_files_wizard: {
        stage_id,
        linked_file_ids: _.map(data.files, 'attachment_id'),
        onLinkFiles: (file_ids) =>
          linkFilesToModel(stage_id, 'Task', data.id, file_ids).then(() => {
            this.props.readAction(data.id).catch(_.noop);
            listAllTasks(stage_id).catch(_.noop);
          }),
      },
    });
  }

  @autobind
  _openUploadPicker() {
    hideDropdown();

    if (this.dropzone) {
      this.dropzone.open();
    }
  }

  render() {
    const { data, collapsed, user_id } = this.props;
    const { is_editor, is_reviewer } = data;

    const comment_files = _.transform(
      data.comments,
      (files, comment) => {
        _.each(comment.files, (file) => {
          files.push({ ...file, source: 'comment', comment_id: comment.id });
        });
      },
      [],
    );

    const files = _.sortBy([...data.files, ...comment_files], ['created_at']);
    const archivedFilesCount = _.size(_.filter(files, (file) => file.archived));
    const visibleFiles = this.state.showArchivedFiles
      ? files
      : _.filter(files, (file) => !file.archived);

    const lightbox_images = _.map(
      _.filter(visibleFiles, (file) =>
        _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext)),
      ),
      (file) => ({
        id: file.id,
        attachment_version_id: file.attachment_version_id,
        stream_url: file.stream_url,
        title: [file.name, file.ext].join('.'),
        download_url: file.download_url,
        ext: file.ext,
        width: file.width,
        height: file.height,
      }),
    );

    return (
      <div
        className={classNames(styles.wrapper, collapsed && styles.collapsed)}
        ref='scroll'
      >
        {!_.isEmpty(files) && (
          <div className={styles.actions}>
            <label className={styles.showArchivedFiles}>
              {archivedFilesCount > 0 ? (
                <>
                  <span>
                    {__('task.flyout.files.show-hide-archived-files')}{' '}
                    {'(' + archivedFilesCount + ')'}
                  </span>
                  <input
                    type='checkbox'
                    checked={this.state.showArchivedFiles}
                    onChange={(e) =>
                      this.setState({ showArchivedFiles: e.target.checked })
                    }
                  />
                </>
              ) : (
                <span>{__('task.flyout.files.no-archived-files')}</span>
              )}
            </label>
            <span
              className={styles.downloadAllTasks}
              onClick={() => this._downloadFiles()}
            >
              {__('meetings.flyout.files.download-all-tasks')}
              <DownloadIcon />
            </span>
          </div>
        )}
        <div className={styles.scroller}>
          {/* {_.isEmpty(files) ? (
            <div className={styles.empty}>
              {__('meetings.flyout.files.there-are-no-files')}
            </div>
          ) : (
            ''
          )} */}

          {_.map(visibleFiles, (row) => {
            const menu_id = [row.source || 'task', row.id].join('-');
            const can_manage_file =
              ((is_reviewer && user_id == _.get(row, 'creator.id')) ||
                is_editor) &&
              !_.includes(['closed', 'canceled'], data.status);
            const can_version_file = can_manage_file;
            return (
              <div
                className={classNames(
                  styles.row,
                  row.archived && styles.archived,
                )}
                key={menu_id}
              >
                <div
                  className={classNames(
                    styles.left,
                    _.includes(
                      ['jpg', 'jpeg', 'png', 'pdf'],
                      _.toLower(row.ext),
                    ) && styles.leftClickable,
                  )}
                  onClick={() => {
                    if (
                      _.includes(
                        ['jpg', 'jpeg', 'png', 'pdf'],
                        _.toLower(row.ext),
                      )
                    ) {
                      showLightbox(lightbox_images, row.id);
                    }
                  }}
                >
                  <FilePreview
                    onDownloadFile={this._downloadFile}
                    row={row}
                    lightbox_images={lightbox_images}
                  />
                </div>
                <div className={styles.right}>
                  <span className={styles.version}>{'V' + row.version}</span>

                  <span className={styles.size}>{bytesToSize(row.size)}</span>

                  <div className={styles.avatar}>
                    <Avatar
                      size={24}
                      {...row.creator}
                      avatar_url={row.creator.avatar_url}
                      className={styles.avatar}
                    />
                  </div>

                  <div className={styles.date_time}>
                    {dateFrom(row.current_version_created_at || row.created_at)}
                    <br />
                    {timeFrom(row.current_version_created_at || row.created_at)}
                  </div>
                  <div className={styles.icons}>
                    <AttachmentFileMenu
                      name={'task_file_menu_' + menu_id}
                      row={row}
                      canManageFile={can_manage_file}
                      canVersionFile={can_version_file}
                      onDownloadFile={this._downloadFile}
                      onOpenEdit={this._openEditAttachment}
                      onOpenUploadVersion={this._openUploadAttachmentVersion}
                      onArchiveAttachment={this._archiveAttachment}
                      onDeleteFile={this._deleteFile}
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {(is_editor || is_reviewer) &&
          !_.includes(['closed', 'canceled'], data.status) && (
            <ReactDropzone
              ref={(dropzone) => {
                this.dropzone = dropzone;
              }}
              className={classNames(
                styles.dropzone,
                _.get(this.state, 'drag') && styles.drag,
              )}
              disableClick
              onDrop={this._handleDrop}
              onDragOver={() => this.setState({ drag: true })}
              onDragLeave={() => this.setState({ drag: false })}
              multiple={true}
            >
              <UploadIcon />
              <span className={styles.dropTitle}>
                {__('dropzone.title.drop-your-file-here')}
              </span>
              <Dropdown
                portal
                top={28}
                right={0}
                name={'task_add_files_' + data.id}
                wrapperClassName={styles.addFilesDropdownWrapper}
                dropdownClassName={styles.addFilesDropdown}
                content={
                  <div className={styles.addFilesMenu}>
                    <div
                      className={styles.addFilesOption}
                      onClick={this._openLinkExistingFilesWizard}
                    >
                      {__('task.flyout.files.browse-from-volum3')}
                    </div>
                    <div
                      className={styles.addFilesOption}
                      onClick={this._openUploadPicker}
                    >
                      {__('task.flyout.files.upload-new')}
                    </div>
                  </div>
                }
              >
                <span className={styles.dropSubtitle}>
                  {__('task.flyout.files.add-files')}
                </span>
              </Dropdown>
            </ReactDropzone>
          )}
      </div>
    );
  }
}

export default Files;
